import { Avatar, Box, Stack, Typography, useTheme } from '@mui/material'
import React from 'react'
import AmbuNetTheme from '../../../../components/Theme'
import { useNavigate } from 'react-router-dom'

const StaffRowComponent = ({ firstName, lastName, photograph, text, id }) => {
  const theme = useTheme()
  const navigate = useNavigate()
  return (
    <Stack
      direction="row"
      alignItems="center"
      spacing={1.5}
      sx={{
        p: 1,
        borderRadius: 2,
        transition: 'all 0.15s ease',
        cursor: 'pointer',
        '&:hover': {
          background: theme.palette.action.hover,
          transform: 'translateY(-1px)',
        },
      }}
      onClick={() => navigate(`/employees/${id}`)}
    >
      <Avatar
        src={photograph}
        sx={{
          borderRadius: 2,
          width: 36,
          height: 36,
        }}
      />

      <Box>
        <Typography fontWeight={600}>
          {firstName} {lastName}
        </Typography>
        {text && (
          <Typography variant="caption" color="text.secondary">
            {text}
          </Typography>
        )}
      </Box>
    </Stack>
  )
}

export default StaffRowComponent
